module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "prelims-page",
    attrs: {
      "id": "d14be04baee4e-d1e230"
    }
  }, [_c('span', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("A Selection of Recent Titles by Marjorie Eccles")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE SHAPE OF SAND")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("SHADOWS AND LIES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LAST NOCTURNE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("BROKEN MUSIC")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE CUCKOO’S CHILD *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("AFTER CLARE *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("A DANGEROUS DECEIT *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("THE FIREBIRD’S FEATHER *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("The Herbert Reardon historical mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("HEIRS AND ASSIGNS *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("* "), _c('em', {
    staticClass: "italic "
  }, [_vm._v("available from Severn House")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-667d1268","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106915_epub_alb.vue
// module id = 63
// module chunks = 0